import firebase from "firebase/compat";

// classes
export const TimeStampClass = firebase.firestore.Timestamp;
export const GeoPointClass = firebase.firestore.GeoPoint;

// types
export type OrderByDirection = firebase.firestore.OrderByDirection;
export type DocumentData = firebase.firestore.DocumentData;
export type Query<T = DocumentData> = firebase.firestore.Query<T>;
export type DocReference<T = DocumentData> = firebase.firestore.DocumentReference<T>;
export type DocChange<T = DocumentData> = firebase.firestore.DocumentChange<T>;
export type CollectionReference<T = DocumentData> = firebase.firestore.CollectionReference<T>;
export type QuerySnapshot<T = DocumentData> = firebase.firestore.QuerySnapshot<T>;
export type QuerySnapshotDocs<T = DocumentData> = Array<firebase.firestore.DocumentSnapshot<T>>;
export type DocumentSnapshot<T = DocumentData> = firebase.firestore.DocumentSnapshot<T>;
export type Timestamp = firebase.firestore.Timestamp;
export type GeoPoint = firebase.firestore.GeoPoint;
export type QueryDocumentSnapshot<T = DocumentData> = firebase.firestore.QueryDocumentSnapshot<T>;
export type StorageReference = firebase.storage.Reference;

// enums
export enum ApplyTimestampType {
  update,
  create,
}
